export const SUGGESTED_FILTERS_2ROW_EXPERIMENT =
  'car-merch-ui-srp-suggested-filters-2row';
